import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUPS_OF_ADMINS_LIST = Symbol('groups-of-admins');
export const GROUPS_OF_ADMINS_MAIN_ROUTE_NAME = Symbol('groups-of-admins.main');
export const GROUPS_OF_ADMINS_LIST_ROUTE_NAME = Symbol('groups-of-admins.list');

export const GROUPS_OF_ADMINS_LIST_QUERY_KEY = 'groups-of-admins.list';
export const GROUPS_OF_ADMINS_LIST_API_URL = 'admin/admin_groups/list';

export const GROUPS_OF_ADMINS_DELETE_MUTATION_KEY = 'groups-of-admins.delete';
export const GROUPS_OF_ADMINS_DELETE_API_URL = 'admin/admin_groups/:id';

export const GROUPS_OF_ADMINS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.ADMINGROUPS_SHOW),
  EDIT: new Permission(PermissionsList.admin.ADMINGROUPS_EDIT),
  DELETE: new Permission(PermissionsList.admin.ADMINGROUPS_DELETE),
};
